import { Facet, FacetOption } from '@constructor-io/constructorio-client-javascript'
import { Aggregation } from '@magentoTypes'

export const mapFilters = (cioFilters: Partial<Facet>[]): Aggregation[] => {
  // preserve structure so no additional refactor of filters is needed
  return cioFilters?.map((cioFilter) => {
    return {
      attribute_code: cioFilter.name as string,
      // TODO: add proper name
      label: cioFilter.display_name,
      options: cioFilter.options.map((cioOption: FacetOption, index: number) => ({
        label: cioOption.display_name,
        // this might be dirty, but because of the fact that value are not unique wording(eg benuta naturals/benuta) and current implementations of
        // filters checking ('benuta naturals'.includes(value) returns true also for 'benuta')
        // i see no other solution until filters will be rewritten
        value: cioOption?.data?.option_id
          ? cioOption?.data?.option_id.toString()
          : `${cioOption.value}id${index}`,
        originalValue: `${cioOption.value}id${index}`,
      })),
    }
  })
}
